define('viewModels/privileged/qm/SurveySummaryView',[
        'lib/knockout',
        'lib/lodash4',

        'services/qualityManagementService',

        'viewModels/ViewModel',
        'util/errorCallbackFactory'
], function (
    ko,
    _,

    qualityManagementService,

    ViewModel,
    errorCallbackFactory
    ) {
    'use strict';

    var SURVEY_SUMMARY_COLUMNS = [
        {
            label: 'surveySummary.formNameTitle',
            id: 'formName'
        },
        {
            label: 'surveySummary.statusTitle',
            id: 'status'
        },
        {
            label: 'surveySummary.scoreTitle',
            id: 'score'
        },
        {
            label: 'surveySummary.npsScore',
            id: 'npsScore'
        }];

    //this function is only here because Math.round() by itself sometimes does not produce correct results
    //i.e if you put in Math.round(1.005 * 100) / 100, you would 1.00, instead of 1.01
    var roundUpDecimals = function(num){
        return +(Math.round(num + "e+2") + "e-2");
    };


    var SurveySummaryView = ViewModel.extend(function(conversationId) {
        var self = this;

        self.surveySummaryGrid = ko.observableArray();

        var getStatusString = function(status) {
            var surveyStatus;
            if(status.toLowerCase() === "pending") {
                surveyStatus = "surveySummary.pending";
            } else if (status.toLowerCase() === "sent") {
                surveyStatus = "surveySummary.sent";
            } else if (status.toLowerCase() === "inprogress") {
                surveyStatus = "surveySummary.inProgress";
            } else if (status.toLowerCase() === "expired") {
                surveyStatus = "surveySummary.expired";
            } else if (status.toLowerCase() === "finished") {
                surveyStatus = "surveySummary.finished";
            } else if (status.toLowerCase() === "optout") {
                surveyStatus = "surveySummary.optOut";
            } else {
                surveyStatus = "surveySummary.error";
            }
            return surveyStatus;
        };

        var getErrorInfo = function(surveyErrorDetails) {
            var reason = surveyErrorDetails.surveyErrorReason.toLowerCase();
            var messageKey;
            if (reason === 'bounce') {
                messageKey = 'surveySummaryView.bounced';
            } else if (reason === 'complaint') {
                messageKey = 'surveySummaryView.complaint';
            } else {
                messageKey = 'surveySummaryView.unspecifiedError';
            }
            return { 'errorString': messageKey, 'lastActionId': surveyErrorDetails.flowDiagnosticInfo.lastActionId };
        };

        self.listEntities = function(surveys) {
            var conversationId, formName, status;
            var errorInfo = {};

            var rows = _.map(surveys, function(survey) {

                conversationId = survey.conversation.id;

                var score = survey.answers && survey.answers.totalScore ?
                    roundUpDecimals(survey.answers.totalScore) :
                    ko.i18n.renderString('evaluatorDashboard.score.unavailable');

                var scoreCell = {
                    totalScore: score
                };

                if (survey.answers) {
                    scoreCell.href = "#admin/interactions/" + conversationId + "/surveys/" + survey.id;
                }

                formName = survey.surveyForm.name;
                status = getStatusString(survey.status);
                
                if (status == 'surveySummary.error' && survey.surveyErrorDetails) {
                    errorInfo = getErrorInfo(survey.surveyErrorDetails);
                }

                return {
                    'conversationId': conversationId,
                    'surveyId': survey.id,
                    'formName': formName,
                    'status': status,
                    'score': scoreCell,
                    'npsScore': survey.answers ? survey.answers.npsScore : undefined,
                    'errorMessageKey': errorInfo.errorString,
                    'lastActionId': errorInfo.lastActionId
                };
            });
            self.surveySummaryGrid().rows(rows);
        };

        self.surveySummaryGrid({
            columns: SURVEY_SUMMARY_COLUMNS,
            rows: ko.observableArray([]),
            selectedRows: ko.observableArray([]),
            loading: ko.observable(true)
        });

        qualityManagementService.getConversationSurveys(conversationId())
            .then(function(response) {
                self.listEntities(response);
            })
            .catch(errorCallbackFactory.createCallback({ namespace: "playback.surveySummaryRequest"}))
            .finally(function() {
                self.surveySummaryGrid().loading(false);
            });
    });

    return SurveySummaryView;
});

